import React from 'react';

export const preventFormDefault = (e: React.FormEvent<HTMLFormElement>) => e.preventDefault();
